import { Injectable } from "@angular/core";
import { Exclusion, Resource } from "../../models/common-table";

@Injectable({
  providedIn: "root",
})
export class CommonTableExclusionService {
  public getStopExclusions(resources: Resource[]): Exclusion[] {
    return resources?.[0]?.exclude ?? [];
  }

  public getStartExclusions(resources: Resource[]): Exclusion[] {
    return resources?.[1]?.exclude ?? [];
  }

  public addExclusion(resources: Resource[], type: "start" | "stop"): void {
    const targetIndex = type === "stop" ? 0 : 1;
    const resource: Resource = resources[targetIndex];

    if (!resource.exclude) {
      resource.exclude = [];
    }

    resource.exclude.push({ key: "", value: "" });
  }
}
